import React, { useState } from 'react';
import './CarbonMarketplace.css';

const CarbonMarketplace = ({ onNext }) => {
  const [notes, setNotes] = useState('');

  const handleBuy = () => {
    alert('🛒 Buy functionality - Connect to payment gateway');
  };

  const handleSell = () => {
    alert('💰 Sell functionality - List your credits');
  };

  const handleProceed = () => {
    alert('✅ Marketplace complete! Returning to dashboard...');
    if (onNext) {
      onNext();
    }
  };

  return (
    <div className="carbon-marketplace">
      <header className="marketplace-header">
        <h1>Carbon Marketplace</h1>
        <p>Global Carbon Trading Platform</p>
      </header>

      <div className="marketplace-container">
        {/* Market Overview */}
        <section className="marketplace-section">
          <div className="marketplace-section-header">Market Overview</div>
          <div className="market-stats-grid">
            <div className="market-stat-card">
              <div className="stat-value">$4,517</div>
              <div className="stat-label">Total Volume</div>
              <div className="stat-change positive">+2.3% ↑</div>
            </div>
            <div className="market-stat-card">
              <div className="stat-value">23</div>
              <div className="stat-label">Active Listings</div>
            </div>
          </div>
        </section>

        {/* Token Allocation */}
        <section className="marketplace-section">
          <div className="marketplace-section-header">Token Allocation</div>
          <div className="allocation-grid">
            <div className="allocation-item">
              <span>Available Tokens:</span>
              <strong>100 BCC</strong>
            </div>
            <div className="allocation-item">
              <span>Listed for Sale:</span>
              <strong>50 BCC</strong>
            </div>
            <div className="allocation-item">
              <span>Reserved:</span>
              <strong>30 BCC</strong>
            </div>
            <div className="allocation-item">
              <span>Retired:</span>
              <strong>20 BCC</strong>
            </div>
          </div>
        </section>

        {/* Market Prices */}
        <section className="marketplace-section">
          <div className="marketplace-section-header">Market Prices</div>
          <div className="prices-grid">
            <div className="price-item">
              <span>Current Price:</span>
              <strong className="price-value">$45.17</strong>
            </div>
            <div className="price-item">
              <span>24h High:</span>
              <strong>$47.23</strong>
            </div>
            <div className="price-item">
              <span>24h Low:</span>
              <strong>$43.89</strong>
            </div>
          </div>
        </section>

        {/* Outstanding Bids */}
        <section className="marketplace-section">
          <div className="marketplace-section-header">Outstanding Bids</div>
          <div className="bids-list">
            <div className="bid-item">
              <div className="bid-info">
                <span className="bid-amount">$73.87</span>
                <span className="bid-details">2.3 tons at $32.12/ton</span>
              </div>
              <div className="bid-buyer">Buyer: 0x7A3F...9B2C</div>
            </div>
            <div className="no-bids">No active bids at this time</div>
          </div>
        </section>

        {/* Transaction History */}
        <section className="marketplace-section">
          <div className="marketplace-section-header">Transaction History</div>
          <div className="transactions-table">
            <div className="transaction-row header">
              <span>Type</span>
              <span>Amount</span>
              <span>Price</span>
              <span>Date</span>
            </div>
            <div className="transaction-row">
              <span className="type-buy">Buy</span>
              <span>1.2 BCC</span>
              <span>$54.20</span>
              <span>14/10/2023</span>
            </div>
            <div className="transaction-row">
              <span className="type-sell">Sell</span>
              <span>0.8 BCC</span>
              <span>$36.16</span>
              <span>13/10/2023</span>
            </div>
          </div>
        </section>

        {/* Market Actions */}
        <section className="marketplace-section">
          <div className="marketplace-section-header">Market Actions</div>
          <div className="market-actions-grid">
            <button className="market-action-btn buy-btn" onClick={handleBuy}>
              <span className="btn-icon">🛒</span>
              Buy Carbon Credits
            </button>
            <button className="market-action-btn sell-btn" onClick={handleSell}>
              <span className="btn-icon">💰</span>
              Sell Carbon Credits
            </button>
          </div>
        </section>

        {/* Market Notes */}
        <section className="marketplace-section">
          <div className="marketplace-section-header">Market Notes</div>
          <textarea
            className="marketplace-textarea"
            placeholder="Add trading notes or observations..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </section>

        {/* Complete Button */}
        <div className="marketplace-actions">
          <button className="marketplace-btn complete-btn" onClick={handleProceed}>
            View Carbon Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarbonMarketplace;
